<div class="box">
  @if (title) {
    <div class="box-header">
      <h3 [innerHTML]="title"></h3>
    </div>
  }
  <div class="box-body" [class.titleless]="title == null || title == ''">
    <div class="content" [innerHTML]="content"></div>
    @if (pageContent.PageSubContents.length > 0) {
      <div class="sub-section">
        <app-page-content-loop [pageContents]="pageContent.PageSubContents"></app-page-content-loop>
      </div>
    }
  </div>
</div>